require('@popperjs/core');
require('bootstrap');
require('./technicals');
require('select2');

require('./legacy/jquery.easing.1.3.js');
require('./legacy/jquery.waypoints.min.js');
// require('./legacy/jquery.stellar.min.js');
require('stellar.js');
require('./legacy/owl.carousel.min.js');
require('./legacy/jquery.magnific-popup.min.js');
require('./legacy/jquery.animateNumber.min.js');
require('./legacy/scrollax.min.js');
require('./legacy/main.js');
require('./form.js');

require('lightbox2');
require('imagesloaded');

import Inputmask from "inputmask";

$(document).ready(function () {
    let selector = document.querySelectorAll(".mask-email");
    Inputmask({alias: "email"}).mask(selector);
});

global.Masonry = window.Masonry = require('masonry-layout');

var masonryGrid;

$(window).on(
    'load',
    function () {
        if ($('.photos').length > 0) {
            new Masonry(
                '#gallery-photos',
                {
                    percentPosition: false
                }
            );
        }
    }
);

if ($('#gallery-photos').length > 0) {
    $('#gallery-photos img').imagesLoaded()
        .progress(function () {
            if (masonryGrid !== null && typeof masonryGrid !== 'undefined') {
                masonryGrid.layout();
            }
        });
}
